module.exports = __webpack_public_path__ + "img/combojetvac_parked.df6dd9b1.svg";